var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Element_24/Device/email/Noir",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.667,13.25 L11.4,13.8 C11.756,14.067 12.244,14.067 12.6,13.8 L13.333,13.25 L18.334,17 L5.666,17 L10.667,13.25 Z M12.734,11.199 C12.734,11.199 12.733,11.199 12.732,11.2 L12,11.75 L11.268,11.2 C11.267,11.199 11.266,11.199 11.266,11.199 L5.666,7 L18.334,7 L12.734,11.199 Z M20,8.249 L20.002,15.752 L14.999,12 L20,8.249 Z M4,8.25 L9.001,12 L4,15.75 L4,8.25 Z M20,5 L4,5 C2.897,5 2,5.897 2,7 L2,17 C2,18.103 2.897,19 4,19 L20,19 C21.103,19 22,18.103 22,17 L22,7 C22,5.897 21.103,5 20,5 L20,5 Z",
    id: "Fill-1",
    fill: "#000000"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.8e4cbcdb159fed3d5c7ff9311d6bc78f.svg";
export { ForwardRef as ReactComponent };